import { RouteObject } from "react-router-dom";
import routePaths from "./routePaths";
import { lazy, ReactNode, Suspense } from "react";
import Header from "../components/Header/Header";
import VerticalMenu from "../components/LeftMenu/VerticalMenu";
import CreateBooking from "../screens/Booking/CreateBooking/CreateBooking";
import ProjectStatusView from "../screens/ProjectStatusView/ProjectStatusView";
import Dashboard from "../screens/Dashboard/Dashboard";
import Customers from "../screens/Customers/Customers";
import Agents from "../screens/Agents/Agents";
import DueReport from "../screens/DueReport/DueReport";
import Project from "../screens/Projects/ProjectPage/Projects";
import CreateProject from "../screens/Projects/CreateProject/CreateProject";
import ProjectUnitPage from "../screens/ProjectsUnit/ProjectUnitPage/ProjectUnitPage";
import CreateProjectUnit from "../screens/ProjectsUnit/CreateUnitProject/CreateProjectUnit";
import Bookings from "../screens/Booking/BookingPage/Bookings";
import ReceiptPage from "../screens/Receipts/ReceiptPage/ReceiptPage";
import CreateReceipt from "../screens/Receipts/CreateReceipt/CreateReceipt";
import Expenses from "../screens/Expenses/ExpensePage/Expenses";
import CreateExpense from "../screens/Expenses/CreateExpense/CreateExpense";
import Users from "../screens/Users/UsersPage/Users";
import MarkUnit from "../screens/MarkUnit/MarkUnit";
import PendingRegistrationUnits from "../screens/ProjectsUnit/PendingRegistrationUnits";
import ExpenseTypePage from "../screens/Expenses/ExpenseTypePage/ExpenseTypePage";
import RolePage from "../screens/Roles/RolePage";
import ExpensesReport from "../screens/ExpensesReport/ExpensesReport";
import ManageTower from "../screens/Projects/CreateProject/ManageTower";
import TowerStatusView from "../screens/ProjectStatusView/TowerStatusView";
import FloorStatusView from "../screens/ProjectStatusView/FloorStatusView";
import SummaryReport from "../screens/SummaryReport/SummaryReport";
import CustomerVoucher from "../screens/CustomerVoucher/CustomerVoucherPage/CustomerVoucher";
import CreateVoucher from "../screens/CustomerVoucher/CreateCustomerVoucher/CreateVoucher";
import CompletedRegistrationUnits from "../screens/ProjectsUnit/CompletedRegistrationUnits";
import BookedUnits from "../screens/ProjectsUnit/BookedUnits";
import Suppliers from "../screens/Suppliers/Suppliers";
import Units from "../screens/Units/Units";
import Stock from "../screens/Stocks/Stock";
import Inventory from "../screens/Inventory/Inventory";
import Royalty from "../screens/Royalty/Royalty";
import AgentReport from "../screens/Agents/AgentReport";
import Loan from "../screens/Loan/Loan";
import DayBook from "../screens/DayBook/DayBook";

const errorElement = () => {
  return <div>error </div>;
};

const getProtectedComponent = (component: ReactNode) => {
  return (
    <div id="main-wraper">
      <Header />
      <div id="main-app" className="layout-veritcle-menu">
        <VerticalMenu />
        <div className="app-body">{component}</div>
      </div>
    </div>
  );
};

const ProtectedRoutes: RouteObject[] = [
  {
    path: routePaths.HOME.path,
    element: (
      <Suspense fallback={<></>}>{getProtectedComponent(<Dashboard />)}</Suspense>
    ),
    caseSensitive: false,
    id: routePaths.DASHBOARD.id,
    errorElement: errorElement(),
    children: [
      {
        index: true,
        path: routePaths.DASHBOARD.path,
        element: getProtectedComponent(<Dashboard />),
      },
    ],
  },
  {
    path: routePaths.PROJECTPAGE.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<Project />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.PROJECTPAGE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.ADD_NEW_PROJECT.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateProject />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.ADD_NEW_PROJECT.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.UPDATE_PROJECT.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateProject />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.UPDATE_PROJECT.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.PROJECT_UNIT_LIST.path + ":id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<ProjectUnitPage />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.PROJECT_UNIT_LIST.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.PROJECT_UNIT_CREATE.path + ":id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateProjectUnit />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.PROJECT_UNIT_CREATE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.PROJECT_UNIT_UPDATE.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateProjectUnit />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.PROJECT_UNIT_UPDATE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.BOOKING.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<Bookings />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.BOOKING.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.BOOKING_CREATE.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateBooking />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.BOOKING_CREATE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.BOOKING_UPDATE.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateBooking />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.BOOKING_UPDATE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.RECEIPT.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<ReceiptPage />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.RECEIPT.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.RECEIPT_CREATE.path + "/:id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateReceipt />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.RECEIPT_CREATE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.RECEIPT_UPDATE.path + ":id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateReceipt />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.RECEIPT_UPDATE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.CUSTOMER_VOUCHER.path + ":id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CustomerVoucher />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.CUSTOMER_VOUCHER.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.CUSTOMER_VOUCHER_CREATE.path + "/:id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateVoucher />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.CUSTOMER_VOUCHER_CREATE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.CUSTOMER_VOUCHER_UPDATE.path + ":id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateVoucher />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.CUSTOMER_VOUCHER_UPDATE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.EXPENSE.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<Expenses />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.EXPENSE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.EXPENSE_CREATE.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateExpense />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.EXPENSE_CREATE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.EXPENSE_UPDATE.path + ":id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CreateExpense />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.EXPENSE_UPDATE.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.USERS.path,
    element: (<Suspense fallback={<></>}>{getProtectedComponent(<Users />)}</Suspense>),
    caseSensitive: false,
    id: routePaths.USERS.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.MARK_UNIT.path + ":id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<MarkUnit />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.MARK_UNIT.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.PROJECT_STATUS_VIEW.path + ":id",
    element: (<Suspense fallback={<></>}>  {getProtectedComponent(<ProjectStatusView />)} </Suspense>),
    caseSensitive: false,
    id: routePaths.PROJECT_STATUS_VIEW.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.CUSTOMER.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<Customers />)} {/* Placeholder for Customer component */}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.CUSTOMER.id,
    errorElement: errorElement(),
  },
  {
    path: routePaths.AGENTS.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<Agents />)} {/* Placeholder for Agents component */}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.AGENTS.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.DUE_REPORT.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<DueReport />)} {/* Placeholder for Due Report component */}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.DUE_REPORT.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.PENDING_REGISTRATION_UNITS.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<PendingRegistrationUnits />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.PENDING_REGISTRATION_UNITS.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.COMPLETED_REGISTRATION_UNITS.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<CompletedRegistrationUnits />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.COMPLETED_REGISTRATION_UNITS.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.BOOKED_UNITS.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<BookedUnits />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.BOOKED_UNITS.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.ADD_EXPENSE_TYPE.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<ExpenseTypePage />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.ADD_EXPENSE_TYPE.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.ADD_EXPENSE_TYPE.path + "/:id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<ExpenseTypePage />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.ADD_EXPENSE_TYPE.id + "_sub",
    errorElement: errorElement()
  },
  {
    path: routePaths.ROLE.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<RolePage />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.ROLE.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.EXPENSES_REPORT.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<ExpensesReport />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.EXPENSES_REPORT.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.MANAGE_TOWER.path + ":id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<ManageTower />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.MANAGE_TOWER.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.TOWER_STATUS_VIEW.path + ":tower_id/:project_id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<TowerStatusView />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.TOWER_STATUS_VIEW.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.FLOOR_STATUS_VIEW.path + ":floor_id/:tower_id/:project_id",
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<FloorStatusView />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.FLOOR_STATUS_VIEW.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.SUMMARY_REPORT.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<SummaryReport />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.SUMMARY_REPORT.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.SUPPLIERS.path,
    element: (
      <Suspense fallback={<></>}>
        {getProtectedComponent(<Suppliers />)}
      </Suspense>
    ),
    caseSensitive: false,
    id: routePaths.SUPPLIERS.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.UNITS.path,
    element: (<Suspense fallback={<></>}> {getProtectedComponent(<Units />)}</Suspense>),
    caseSensitive: false,
    id: routePaths.UNITS.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.STOCKS.path,
    element: (<Suspense fallback={<></>}> {getProtectedComponent(<Stock />)}</Suspense>),
    caseSensitive: false,
    id: routePaths.STOCKS.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.INVENTORY.path,
    element: (<Suspense fallback={<></>}> {getProtectedComponent(<Inventory />)}</Suspense>),
    caseSensitive: false,
    id: routePaths.INVENTORY.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.ROYALTY.path,
    element: (<Suspense fallback={<></>}> {getProtectedComponent(<Royalty />)}</Suspense>), // Placeholder for Royalty component
    caseSensitive: false,
    id: routePaths.ROYALTY.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.AGENT_COMMISSION_REPORT.path,
    element: (<Suspense fallback={<></>}>        {getProtectedComponent(<AgentReport />)}       </Suspense>),
    caseSensitive: false,
    id: routePaths.AGENT_COMMISSION_REPORT.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.LOAN.path,
    element: (<Suspense fallback={<></>}>{getProtectedComponent(<Loan />)}</Suspense>),
    caseSensitive: false,
    id: routePaths.LOAN.id,
    errorElement: errorElement()
  },
  {
    path: routePaths.DAY_BOOK.path,
    element: (<Suspense fallback={<></>}>{getProtectedComponent(<DayBook />)}</Suspense>),
    caseSensitive: false,
    id: routePaths.DAY_BOOK.id,
    errorElement: errorElement()
  }
];

export default ProtectedRoutes;
